import React from 'react';
import UserInput from '../Input';
import TextBase from '../Typography/TextBase';

function ProductFilterPrice({
  price,
  initialPriceRange,
  setPrice,
  valueChanged,
  setValueChanged,
}) {
  const handleRangeChange = (range) => {
    setPrice([...range]);
    setValueChanged(true);
  };

  if (initialPriceRange[0] <= 0) {
    return null;
  }

  return (
    <div className="product-filter-price">
      <TextBase
        text="Price Range"
        className="text-base font-semibold capitalize mb-16"
      />
      <UserInput
        type="range-slider"
        min={initialPriceRange[0]}
        max={
          initialPriceRange[0] === initialPriceRange[1]
            ? initialPriceRange[1] + 1
            : initialPriceRange[1]
        }
        values={price}
        step={10}
        initialValues={initialPriceRange}
        onChange={handleRangeChange}
        valueChanged={valueChanged}
      />
      <div className="my-[16px] border-b border-aquarelle-purple" />
    </div>
  );
}

export default ProductFilterPrice;
